import { Alert, Icon, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

import { DraggableWatchlistRow } from '../draggable-watchlist-row/DraggableWatchlistRow';
import { TableWatchlistManagerWidget } from '../table-watchlist-manager-widget/TableWatchlistManagerWidget';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: hidden;
`;

export const ContentContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  overflow: hidden;
  height: 100%;

  ${DraggableWatchlistRow.Styled.CellContentWrapper} {
    width: 20px;
  }

  ${TableWatchlistManagerWidget.Styled.StyledTanStackTableRoot} {
    border-left: none;
  }

  ${DraggableWatchlistRow.Styled.StyledTableCell} {
    background-color: transparent;
  }

  ${TableWatchlistManagerWidget.Styled.StyledTableHeader} {
    &:hover {
      background-color: var(--background-default);
    }
  }

  ${TableWatchlistManagerWidget.Styled.StyledTableCell} {
    background-color: transparent;
    &:hover {
      cursor: default;
    }
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 36px;
  margin-top: auto;
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: end;
  flex: 1;
  gap: 10px;
  width: 100%;
`;

export const ErrorMessage = styled.p`
  color: var(--text-critical);
  ${typographyV2.titleBase}
`;

export const StyledIcon = styled(Icon)`
  margin-right: 8px;
`;

export const Label = styled.p`
  color: var(--text-soft);
  ${typographyV2.bodyBase}
`;

export const StyledAlert = styled(Alert)`
  margin-top: 8px;
  width: 100%;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
`;

export const Separator = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const SeparatorLine = styled.div`
  flex: 1;
  height: 1px;
  background-color: var(--border-soft);
`;

export const SeparatorText = styled.span`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;
